var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.859 4.329-5.433 8.06c-.375.548.347 1.213.867.75l5.345-4.65c.143-.116.345-.03.345.172v14.532c0 .202-.26.29-.375.145L8.43 3.98C7.912 3.347 7.161 3 6.323 3h-.577C4.242 3 3 4.242 3 5.773v20.455a2.774 2.774 0 0 0 5.142 1.444l5.432-8.06c.375-.55-.347-1.214-.867-.751l-5.345 4.623c-.144.116-.346.03-.346-.173V8.807c0-.202.26-.29.375-.145l16.18 19.357c.52.634 1.3.981 2.109.981h.577a2.774 2.774 0 0 0 2.773-2.772V5.773C29 4.243 27.76 3 26.228 3c-.954 0-1.85.491-2.37 1.329v-.001z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNear);
export default __webpack_public_path__ + "static/media/NEAR.aa3b2a735a1527c968eb5d7c85208358.svg";
export { ForwardRef as ReactComponent };